// src/pages/DocsPage.js
import React from 'react';

const DocsPage = () => {

  return (
    <div style={{ color: '#fff', padding: '20px' }}>
      <div style={{ marginBottom: '40px' }}>
        <h2>Worker NFT Minting</h2>
        <p>
          The Worker collection currently supports 1,100 NFTs. Available NFTs appear
          in the gallery, which follows the collection's live supply limit. Paid
          mints and admin-issued NFTs count toward the same limit.
        </p>
        <p>
          Every Worker NFT has its own ID. The gallery and NFT details use the same
          collection artwork, including for IDs above 999.
        </p>
      </div>
      {/* Support & Community Section */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #555', paddingBottom: '10px' }}>
          Support and Community
        </h2>
        <ul style={{ lineHeight: '1.8' }}>
          <li>
            <strong>Twitter Community:</strong>{' '}
            <a href="https://twitter.com/sogni_protocol" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://twitter.com/sogni_protocol
            </a>
          </li>
          <li>
            <strong>Discord Community:</strong>{' '}
            <a href="https://discord.sogni.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://discord.sogni.ai
            </a>
          </li>
          <li>
            <strong>Telegram Community:</strong>{' '}
            <a href="https://t.me/sogniai" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://t.me/sogniai
            </a>
          </li>
          <li>
            <strong>Full Sogni Docs:</strong>{' '}
            <a href="https://docs.sogni.ai/" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://docs.sogni.ai/
            </a>
          </li>
          <li>
            <strong>Become a Fast Worker docs:</strong>{' '}
            <a href="https://docs.sogni.ai/sogni-fast-worker/about-sogni-fast-worker" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://docs.sogni.ai/sogni-fast-worker/about-sogni-fast-worker
            </a>
          </li>
          <li>
            <strong>Youtube:</strong>{' '}
            <a href="https://www.youtube.com/@SogniAI" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
              https://www.youtube.com/@SogniAI
            </a>
          </li>
          <li>
            <strong>Technical Support:</strong>{' '}
            Access our support portal or email us at{' '}
            <a href="mailto:app@sogni.ai" style={{ color: '#39ff14' }}>
              app@sogni.ai
            </a>.
          </li>
        </ul>
      </div>

      {/* ------------------------------------------------------------ */}
      {/*                   NEW – TOKEN INFORMATION                    */}
      {/* ------------------------------------------------------------ */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #555', paddingBottom: '10px' }}>
          Token Information
        </h2>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95rem' }}>
          <tbody>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444', width: '180px' }}><strong>Token Name</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>Sogni AI</td>
            </tr>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444' }}><strong>Token Ticker</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>SOGNI</td>
            </tr>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444' }}><strong>Listing Date</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>July&nbsp;2,&nbsp;2025</td>
            </tr>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444' }}><strong>Contract Address</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>
                <div style={{ marginBottom: '4px' }}>Base:&nbsp;
                  <code style={{ color: '#b5ff16' }}>
                    0xE014d2A4da6E450f21b5050120D291e63c8940FD
                  </code>
                </div>
                <div>Etherlink:&nbsp;
                  <code style={{ color: '#b5ff16' }}>
                    0x2767Fc1048cd0ae4fd952eeF09853301c9DC7173
                  </code>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444' }}><strong>Token Bridge</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>
                <a href="https://bridge.etherlink.com/evm" target="_blank" rel="noopener noreferrer" style={{ color: '#39ff14' }}>
                  https://bridge.etherlink.com/evm
                </a>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px', border: '1px solid #444' }}><strong>Total Supply</strong></td>
              <td style={{ padding: '8px', border: '1px solid #444' }}>10,000,000,000</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Legal and Liability Disclaimers */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #555', paddingBottom: '10px' }}>
          Legal and Liability Disclaimers
        </h2>
        <div style={{ lineHeight: '1.8' }}>
          <h4>Compliance with Local Laws</h4>
          <p>By participating, you agree to comply with all relevant laws. Sogni is not responsible for legal issues. Sogni monitors regulations to ensure compliance.</p>

          <h4>Assumption of Risk</h4>
          <p>Operating a node involves risks like hardware wear, electricity cost, and software issues. By participating, you accept these risks.</p>

          <h4>Limitation of Liability</h4>
          <p>Sogni is not liable for direct or indirect damages, financial loss, or device damage, even if advised of such possibilities.</p>

          <h4>No Guarantee of Earnings</h4>
          <p>Earnings vary; no minimum is guaranteed.</p>

          <h4>No Employee or Agency Relationship</h4>
          <p>You’re an independent participant, not an employee of Sogni.</p>

          <h4>Indemnification</h4>
          <p>You agree to hold Sogni harmless from any claims arising from your participation.</p>

          <h4>Software Use at Your Own Risk</h4>
          <p>The software is “as is” without warranties. Use at your own risk.</p>

          <h4>Agreement to Terms</h4>
          <p>By operating a node, you acknowledge and agree to these terms and disclaimers.</p>
        </div>
      </div>
    </div>
  );
};

export default DocsPage;
